import {db} from "@/modules/localDB/localDB"

/**
 * Called once after the necessary book data have been loaded.
 * Will be used to restore last read and tool history
 * @returns {Promise<*>}
 */
const getCurrentLocalHistory = async ()=>{

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .first();
}

export { getCurrentLocalHistory }